"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checklistReducer = exports.getDiscarded = exports.itemsSelected = exports.CART_PAGE = void 0;
exports.CART_PAGE = '/cart';
const itemsSelected = (list) => {
    return Object.keys(list).some((item) => list[item]);
};
exports.itemsSelected = itemsSelected;
const getDiscarded = (checkList) => Object.entries(checkList)
    .filter(([, shouldRecover]) => !shouldRecover)
    .map(([productId]) => productId);
exports.getDiscarded = getDiscarded;
const checklistReducer = (acc, curr) => {
    if (!curr.product_id)
        return acc;
    return Object.assign(Object.assign({}, acc), { [curr.product_id]: true });
};
exports.checklistReducer = checklistReducer;
